import {HTTP} from '@/http-common'

export default {
  actions: {
    createProductLoginToken ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        HTTP.get(`device_login_cookie/${payload.mac}`, {
          withCredentials: true
        })
          .then((response) => {
            resolve(response.data)
          })
          .catch(err => {
            commit('setError', err.response || err)
            try {
              reject(err.response.data.error)
            } catch (e) {
              reject(err)
            }
          })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/device_login_cookie/index.js